/**
 * A semantic version string representing the currently running version of
 * Electron in this ToDesktop instance.
 * @public
 */
export const getElectronVersion = () => window["todesktop"].electronVersion;
